// import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({

  questionImg: {
    width: "150px",
    height: "150px",
    marginRight: "2.5rem",
    cursor: "pointer",
    // position: 'absolute',
    zIndex: "5",
    userDrag: 'none',
    // [mobileScreen(theme)]: {
    //   width: "100px",
    //   height: "100px",
    //   marginRight: "1.5rem",
    // }
  },

  serviceTitle: {
    color: "#003e4c",
    fontSize: "20px",
    fontWeight: "500",
    fontFamily: "Oswald",
    marginBottom: "4px",
    textTransform: "uppercase",
    // [mobileScreen(theme)]: {
    //   fontSize: "15px",
    //   marginBottom: "2px"
    // }
  },

  serviceDesc: {
    color: "#003e4c",
    fontSize: "15px",
    fontWeight: "400",
    fontFamily: "Rubik",
    maxWidth: "350px",
    lineHeight: "1.2",
    // [mobileScreen(theme)]: {
    //   fontSize: "12px",
    //   maxWidth: "200px",
    // }
  },

  iconTraceBack: {
    width: "143px",
    height: "143px",
    position: "absolute",
    zIndex: "3",
    top: "0",
    borderRadius: "50%",
    border: "3px dashed #003e4c",
    backgroundColor: "#ecf2f1",
    // [mobileScreen(theme)]: {
    //   width: "93px",
    //   height: "93px",
    // }
  },

  draggableMainContainer: {
    width: "150px",
    height: "150px",
    position: "relative",
    // [mobileScreen(theme)]: {
    //   width: "100px",
    //   height: "100px",
    // }
  },

  draggableContainer: {
    width: "150px",
    height: "150px",
    position: "absolute",
    zIndex: "10",
    // [mobileScreen(theme)]: {
    //   width: "100px",
    //   height: "100px",
    // }
  },

  draggableElement: {
    width: "550px",
    flexWrap: "nowrap",
    // [mobileScreen(theme)]: {
    //   width: "325px",
    // }
  }

});

export default styles;
